import type { LoadingStatus } from 'types/common_types';

export type CollectionName = string | null;

export type Collection = { name: CollectionName; count: number; thumb: string | null };
export type UncollectedCollection = Collection & { name: null };
export type NamedCollection = Collection & { name: string; thumb: string };

export type PendingCollectionAction =
  | 'create_from_upload'
  | 'create_from_existing'
  | 'create_from_orphans';

export type PhotoUpload = {
  id: number;
  session_id: string;
  ink_url: string;
  created_at: string;
  updated_at: string;
  file_path_thumb: string;
  file_path_1024: string;
  file_path_1024_bw: string;
  file_path_1024_sepia1: string;
  file_path_1024_sepia2: string;
  file_path_thumb_bw: string;
  file_path_thumb_sepia1: string;
  file_path_thumb_sepia2: string;
  customer_id: string;
  original_filename: string;
  is_archived: boolean;
  adjusted_filename: string | null;
  sort_index: number;
  collection: CollectionName;
};

export type PhotosSliceInitialState = {
  status: LoadingStatus;
  /** Name of the collection in the filmstrip */
  activeCollection: CollectionName;
  /** Name of collection to assign newly uploaded photos */
  newUploadsCollection: string;
};
